import { render, staticRenderFns } from "./divideList.vue?vue&type=template&id=beac796c&scoped=true&"
import script from "./divideList.vue?vue&type=script&lang=js&"
export * from "./divideList.vue?vue&type=script&lang=js&"
import style0 from "./divideList.vue?vue&type=style&index=0&id=beac796c&prod&scoped=true&lang=css&"
import style1 from "./divideList.vue?vue&type=style&index=1&id=beac796c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beac796c",
  null
  
)

export default component.exports